/* eslint-disable no-restricted-exports */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable func-names */
/* eslint-disable no-bitwise */
const GetFringerPrint = (function (window, screen, navigator) {
  // https://github.com/darkskyapp/string-hash
  function checksum(str) {
    let hash = 5381;
    let i = str.length;

    // eslint-disable-next-line no-cond-assign
    while (i -= 1) hash = (hash * 33) ^ str.charCodeAt(i);

    return hash >>> 0;
  }

  // http://stackoverflow.com/a/4167870/1250044
  function map(arr, fn) {
    let i = 0;
    const len = arr.length;
    const ret = [];
    while (i < len) {
      ret[i] = fn(arr[i]);
      i += 1;
    }
    return ret;
  }

  return checksum(
    [
      navigator.userAgent,
      [screen.height, screen.width, screen.colorDepth].join('x'),
      new Date().getTimezoneOffset(),
      !!sessionStorage,
      !!localStorage,
      map(navigator.plugins, (plugin) => [
        plugin.name,
        plugin.description,
        map(plugin, (mime) => [mime.type, mime.suffixes].join('~')).join(','),
      ].join('::')).join(';'),
    ].join('###'),
  );
}(this, window.screen, window.navigator));

export { GetFringerPrint as default };
